export const badgeColors: any = {
  "pendente de análise": "#ED6C02CC",
  "aguardando gerente": "#ED6C02CC",
  "aguardando aprovação": "#ED6C02CC",
  "aguardando recebimento": "#ED6C02CC",
  "revisando simulação": "#ED6C02CC",
  "em análise": "#ED6C02",
  "em emissão": "#ED6C02",
  // Lilás: subetapas que dependem de ação do autônomo
  "contraproposta e ajustes": "#7E57C2",
  triagem: "#ED6C02",
  "contrato pendente": "#ED6C02",
  "pendente aprovação comercial": "#ED6C02",
  "pv - revisar proposta - pendência backoffice": "#7E57C2",
  "pv - revisar proposta": "#7E57C2",
  pv: "#9F4951",
  aprovada: "#2196F3",
  "aprovada mediante": "#2196F3",
  "aprovado mediante": "#2196F3",
  "aprovada para conformidade": "#2196F3",
  "em conferência": "#2196F3",
  "aprovada conferência checklist": "#2196F3",
  "aprovado checklist": "#2196F3",
  "contrato pronto": "#2196F3",
  "mesa (cliente)": "#2196F3",
  "distribuição de comissão": "#2196F3",
  "contrato assinado sem confirmação ato": "#577CFF",
  "contrato assinado sem documentação": "#577CFF",
  "contrato assinado": "#577CFF",
  "recusado checklist": "#F43636",
  rejeitada: "#F43636",
  reprovada: "#F43636",
  "pendente documentação": "#F43636",
  "documentação completa": "#70BF73",
  "montando simulação": "#a3a3a6",
  "comissão distribuída": "#70BF73",
  "input condicionado": "#ED6C02",
  "pendência de contrato": "#F43636",
  "aguardando distribuição": "#ED6C02",
  "em distribuição": "#ED6C02",
};
